import React from "react";

const render = (category) => <>{category?.name}</>;

export default render;
